import { Instagram, Linkedin, Mail } from "react-feather";

const socials = [
	{
		service: "mail",
		link: "mailto:epmoc@iiitu.ac.in",
		username: "epmoc@iiitu.ac.in",
		icon: <Mail />,
	},
	{
		service: "instagram",
		link: "https://www.instagram.com/epmoc_/",
		username: "epmoc_",
		icon: <Instagram />,
	},
	{
		service: "linkedin",
		link: "https://www.linkedin.com/company/epmoc-iiitu/",
		username: "epmoc-iiitu",
		icon: <Linkedin />,
	},
];

export default socials;
